/* Every list in the client used to be fetched whole - the parts screens asked
 * the API for `per_page: 1000` and handed all thousand rows to antd at once,
 * which is what made those screens crawl. Paging is what fixed that.
 *
 * The ceiling is now 100, and it is the API's ceiling too
 * (Api::V1::Clients::BaseController::MAX_PER_PAGE). The two have to agree: the
 * API trims anything larger and reports what it applied, so an option the
 * server will not honour shows the client a page size that silently is not the
 * one they picked. The 1000-row option is what had to go - at 1000 a page the
 * catalogue rate limit was worth 120,000 rows every five minutes, which is a
 * whole catalogue and so no limit at all. */
export const DEFAULT_PAGE_SIZE = 100;

// Strings because antd compares them against the select's option values.
export const PAGE_SIZE_OPTIONS = ['10', '20', '50', '100'];
